module.exports = __webpack_public_path__ + "static/bbb-ogi-762bb09bb6792c637e37f453cb60db24.jpg";